import type { PropsWithChildren } from 'react';
import { useQuery } from '@tanstack/react-query';
import type { ProfileResponse } from '@masha/shared';
import { ConsentScreen } from './ConsentScreen';

/**
 * Sits right under RequireAuth: while the server says consentRequired, every
 * route renders the consent screen instead (payments and admin included).
 */
export function RequireConsent({ children }: PropsWithChildren) {
  const { data } = useQuery<ProfileResponse>({ queryKey: ['profile'] });
  if (!data) return null;
  if (data.user.consentRequired) return <ConsentScreen hasPhone={data.user.hasPhone} />;
  return <>{children}</>;
}
